import { useWatch } from '../../../contexts';
import { useConditionValueFieldPath } from '../fieldPaths/useConditionValueFieldPath';

export const useConditionValueWatch = () => {
  const fieldPath = useConditionValueFieldPath();
  return useWatch({ name: fieldPath });
};
